<template>
  <div class="body">
    <div class="mofang">
      <nav>
        <p class="title"><a-icon type="left"  class="go-left"/>朋友圈</p>
      </nav>
      <div class="content">
        <a-row :gutter="0">
          <a-col :span="4">
            <a-avatar shape="square" icon="user" />
          </a-col>
          <a-col :span="18">
            <p class="name">发单小助手</p>
            <div v-html="`<div>${info.text ? info.text : ''}</div>`"></div>
            <div class="imgs" v-if="info.type === 1">
              <a-avatar v-for="(item, index) in info.imgs" :key="index" class="img" shape="square" :size="60" :src="item.response ? item.response.url : item.url" />
            </div>
            <div class="video" v-if="info.type === 3">
              <video :style="{width: '100%',maxHeight:'300px'}" controls v-if="info.video.length > 0" :src="videoUrl"></video>
            </div>
            <div class="comments">
              <div v-for="(item, index) in info.message" :key="index">
                <div class="comment" v-if="item != ''">
                  <span class="name">发单小助手</span>
                  :<span class="message">{{ item }}</span>
                </div>
              </div>
              
              <!-- <div class="comment">
                <span class="name">发单小助手</span>
                :<span class="message">这是评论~</span>
              </div> -->
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      videoUrl: ''
    }
  },
  props: {
    info: {
      type: Object
    }
  },
  watch: {
    info: {
      handler(val, oldVal){
        if (val.video[0]){
          // console.log(val.video[0])
          if (val.video[0].response) {
            this.videoUrl = val.video[0].response.url
          } else {
            this.videoUrl = val.video[0].url
          }
        }
        // console.log("b.c: "+val.c, oldVal.c);
      },
      deep:true
    }
  }
}
</script>
<style lang="less" scoped>
.body{
  position: relative;
  width: 330px;
  margin-top: 100px;
  height: 645px;
  // top: 50%;
  background: url(~@/assets/mobile.png) no-repeat;
  background-size: 100%;
  .mofang {
    position: absolute;
    top: 64px;
    left: 21px;
    right: 23px;
    bottom: 22px;
    overflow: hidden;
    border-radius: 0 0 35px 35px;
    border: 1px solid #edf0f4;
    border-top: none;
    background-color: #edf0f4;
    nav{
      // background: #333;
      .title{
        font-size: 15px;
        font-weight: bolder;
      }
      .go-left{
        margin: 0 3px;
      }
    }
    .content{
      padding: 10px;
      background: #FFF;
      height: -webkit-fill-available;
      .name{
        color: #2173dc;
        font-weight: bold;
      }
      .imgs {
        .img{
          margin: 1px;
        }
      }
      .comments{
        background: #edf0f4;
        margin-top: 9px;
        font-size: 12px;
        border-radius: 5px;
        .comment{
          padding: 5px;
        }
        .name{
          font-weight: noraml;
        }
      }
    }
  }
}
</style>
